import { useContext, useEffect, useState } from "react";
import { ParagraphText, UBInput } from "../../../Libraries";
import TabAutoComplete from "../../../Libraries/TabAutoComplete";
import { LanguageContext } from "../../../context/LanguageContext";
import { Fragment } from "react";
import { formatNum } from "../../../oscar-pos-core/constants";
import { updatedPaymentMethods } from "../../../constants";
import styles from "../NetCalculationCard/styles.module.css";
import { CloseIcon } from "../../../assets/icons/icon";

const paymentMethodList = updatedPaymentMethods.map((m) => ({
  ...m,
  id: m.name,
  label: m.display_name,
  value: m.display_name,
  img: null,
}));

const SelectAmountSummary = ({
  selectAmountType,
  setReceivedAmt,
  receivedAmt,
  handleReceivedAmount,
  netTotalAmt,
  balanceAmount,
  ItemList,
  type,
  handlePaymentLogEvent,
  isRecievedAmountField = true,
}) => {
  const [I18n] = useContext(LanguageContext);
  const [isShow, setShow] = useState(false);

  useEffect(() => {
    if (receivedAmt?.value && !isShow) setShow(true);
    else if (receivedAmt?.value === null && isShow) setShow(false);
  }, [receivedAmt?.value]);

  const removeAdvance = () => {
    setReceivedAmt({ edit: false, value: "", paymentMethod: null });
    setShow(false);
  };
  return (
    <Fragment>
      {isRecievedAmountField && (
        <Fragment>
          <div
            className={`subtotalCardInnerRow subtotalCardInnerInputRow selectAmount ${styles.subtotalCardInnerRow} ${styles.subtotalCardInnerInputRow}`}
          >
            <div
              className={`subtotalCardInnerRowLeft cursorPointer ${styles.subtotalCardInnerRowLeft}`}
            >
              <ParagraphText
                className="discountAndTaxLabel fontSize14 fontWeight500 newFontColor"
                style={{
                  textDecoration: receivedAmt?.value ? "none" : "underline",
                }}
                onClick={() => !receivedAmt?.value && setShow(true)}
              >
                {receivedAmt?.value
                  ? I18n.payment_received_added
                  : I18n.payment_received}
              </ParagraphText>
              {receivedAmt?.value ? (
                <ParagraphText
                  className="pointer fontSize13"
                  style={{ color: "var(--foundationBlueDark)" }}
                  onClick={removeAdvance}
                >
                  <span className={styles.closeIcon}>
                    <CloseIcon />
                  </span>
                </ParagraphText>
              ) : null}
            </div>
            <div
              className={`subtotalCardInnerRowRight ${styles.subtotalCardInnerRowRight}`}
            >
              {isShow && (
                <UBInput
                  tabIndex={0}
                  inputId={
                    selectAmountType === "purchase"
                      ? "enter_paid_amount"
                      : "enter_recieved_amount"
                  }
                  inputClassname="selectAmountInput"
                  baseClassname="selectInputWrapper"
                  placeholder={"Rs."}
                  disabled={!netTotalAmt}
                  value={receivedAmt?.value}
                  onChange={(e, value) => {
                    handleReceivedAmount(value);
                  }}
                />
              )}
            </div>
          </div>

          {isShow && (
            <div
              className={`subtotalCardInnerRow subtotalCardInnerInputRow selectCaseDropdown ${styles.subtotalCardInnerRow} ${styles.subtotalCardInnerInputRow} ${styles.selectCaseDropdown}`}
            >
              <>
                <div
                  className={`subtotalCardInnerRowLeft ${styles.subtotalCardInnerRowLeft}`}
                >
                  <ParagraphText className="fontSize14 fontWeight500 newFontColor">
                    Payment method
                  </ParagraphText>
                </div>
                <div
                  className={`subtotalCardInnerRowRight ${styles.subtotalCardInnerRowRight}`}
                >
                  <TabAutoComplete
                    id="payment_method_id"
                    list={paymentMethodList}
                    value={receivedAmt?.paymentMethod?.display_name || ""}
                    placeholder="Cash/Bank"
                    className="createInvoicePaymentMethodField"
                    handleSelect={(item) => {
                      setReceivedAmt((r) => ({ ...r, paymentMethod: item }));
                    }}
                    handleStartLogEvent={handlePaymentLogEvent}
                  />
                </div>
              </>
            </div>
          )}
        </Fragment>
      )}

      <div className={`subtotalCardInnerRow ${styles.subtotalCardInnerRow}`}>
        <div
          className={`subtotalCardInnerRowLeft ${styles.subtotalCardInnerRowLeft}`}
        >
          <ParagraphText className={"fontSize16 newFontColor"}>
            {I18n.total}
          </ParagraphText>
        </div>
        <div
          className={`subtotalCardInnerRowRight ${styles.subtotalCardInnerRowRight}`}
        >
          <ParagraphText className="fontSize16 newFontColor">
            Rs. {formatNum(balanceAmount) || 0}
          </ParagraphText>
        </div>
      </div>
    </Fragment>
  );
};

export default SelectAmountSummary;
